import React from 'react';
import ReactDOM from 'react-dom/client';

/* hashRouter vermeidet Absturz bei Seitenaktualisierung (F5), 
  Hash-Teil der Route (#/yarn) wird nur vom Browser interpretiert
  Absturz passiert duch Single-Page bei React */
import { createHashRouter, RouterProvider, } from "react-router-dom";

import './index.css';
import App from './App';
import KnittingmachinetypePage from './pages/KnittingmachinetypePage';
import YarnPage from './pages/YarnPage';
import BasicYarnPage from './pages/BasicYarnPage';
import ContactingrecipePage from './pages/ContactingrecipePage';
import UserAdministrationPage from './pages/UserAdministrationPage';
import KnittingmachineConfigurationPage from './pages/KnittingmachineConfigurationPage';


//const router = createBrowserRouter([
const router = createHashRouter([
  {
    path:"knittingmachinetype",
    element: <KnittingmachinetypePage/>,
  },
  {
    path:"knittingmachineconfiguration",
    element: <KnittingmachineConfigurationPage/>,
  },
  {
    path:"contactingrecipe",
    element: <ContactingrecipePage/>,
  },
  {
    path:"yarn",
    element: <YarnPage/>,
  },
  {
    path:"basicyarn",
    element: <BasicYarnPage/>,
  },
  {
    path:"administration",
    element: <UserAdministrationPage/>,
  },
  {
    path:"/",
    element: <App/>,
  },
  

]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(  
  <RouterProvider router={router} />  
);
